import { debounce, generate6DigitUUID } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { MESSAGE_ACTION, MESSAGE_TYPE } from '../../consts/enum';
import { typingIndicatorOptions } from './typingIndicator.model';
import './typingIndicator.scss';

export class TypingIndicatorModule {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initEvent();
	}

	initData(propData = {}) {
		this.data = typingIndicatorOptions;
		this.setter(propData);
		this.data.id = propData.id || `message-${generate6DigitUUID()}`;
	}

	initWrapper() {
		const { id } = this.data;
		const wrapper = document.createElement('div');
		const textTemplateForIndicator = '<strong>Typing...</strong>';
		wrapper.id = id;
		wrapper.className = 'engt-hidden';
		wrapper.innerHTML = textTemplateForIndicator;

		this.html = wrapper;
	}

	initEvent() {
		ENGT_CHAT.set('showTypingIndicator', debounce(showTypingIndicator, 1000));
		ENGT_CHAT.set('addTypingIndicatorElement', addTypingIndicatorElement);
		ENGT_CHAT.set('removeTypingIndicatorElement', removeTypingIndicatorElement);
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}

const addTypingIndicatorElement = (id) => {
	const typingIndicator = document.getElementById(id);
	const chatContentWrapper = document.getElementById('engtChatContent');
	if (typingIndicator) {
		chatContentWrapper.style.paddingBottom = '24px';
		typingIndicator.classList.remove('engt-hidden');
		typingIndicator.classList.add('engt-show-typing-indicator');
		typingIndicator.classList.add('engt-typing-indicator');
		typingIndicator.classList.add('engt-typing-indicator-bottom-up');
	}
};

const removeTypingIndicatorElement = (id) => {
	const typingIndicator = document.getElementById(id);
	if (typingIndicator) {
		typingIndicator.classList.remove('engt-show-typing-indicator');
		typingIndicator.classList.remove('engt-typing-indicator');
		typingIndicator.classList.remove('engt-typing-indicator-bottom-up');
		typingIndicator.classList.add('engt-hidden');
	}
};

const showTypingIndicator = (data, id) => {
	const message = data['message'];
	const msg_type = message['type'];
	const botName = ENGT_CHAT.get('config.bot_name');
	const name = data['agent_name'] || botName;
	const typingIndicator = document.getElementById(id);

	// Will add conditions for showing the agent name once the agent_name is coming.
	if (typingIndicator) {
		const typingSuffix = ENGT_CHAT.get('GENERIC_STRINGS')?.TYPING + '...' || 'is typing...';
		document.getElementById(id).innerHTML = `<strong>${name}</strong> ` + typingSuffix;
	}
	if (msg_type === MESSAGE_TYPE.TYPING_INDICATOR) {
		if (message['action'] === MESSAGE_ACTION.TYPING_ON) {
			addTypingIndicatorElement(id);
			if (ENGT_CHAT.get('clearTimeoutTypingOff')) {
				clearTimeout(ENGT_CHAT.get('clearTimeoutTypingOff'));
			}
			ENGT_CHAT.set(
				'clearTimeoutTypingOff',
				setTimeout(() => {
					removeTypingIndicatorElement(id);
				}, 10000)
			);
		} else {
			removeTypingIndicatorElement(id);
			clearTimeout(ENGT_CHAT.get('clearTimeoutTypingOff'));
		}
	} else {
		removeTypingIndicatorElement(id);
		clearTimeout(ENGT_CHAT.get('clearTimeoutTypingOff'));
	}
};
